/**
 * Rezolucija backend API base URL-a iz env varijabli.
 * Prioritet: REACT_APP_API_BASE_URL → REACT_APP_API_FALLBACK_URL.
 *
 * @returns {string}
 */
export function resolveApiBaseUrl() {
  const explicit = String(process.env.REACT_APP_API_BASE_URL ?? '').trim();
  if (explicit) return explicit;

  const fallback = String(process.env.REACT_APP_API_FALLBACK_URL ?? '').trim();
  if (fallback) return fallback;

  return '';
}
